import { Moment } from 'moment'
import { ConfirmBillPaymentRequest } from 'src/queries/payments/payments.types'

export const BILL_PAYMENT_ACKNOWLEDGEMENT = {
  copy:
    "By confirming, you're authorizing this ACH payment to be sent to the vendor's bank account on file. We'll run a standard compliance check before it goes out, and the vendor will get an email once it's sent. ACH payments have no fee.",
  version: '2026-08-04.v1',
} as const

export interface BillPaymentDraftInput {
  vendorId: string
  amount: number
  invoiceNumber: string
  invoiceDate?: Moment
  dueDate?: Moment
  memo: string
}

export const buildConfirmBillPaymentRequest = (
  draft: BillPaymentDraftInput,
  invoiceAttachmentId: string | null,
): ConfirmBillPaymentRequest => ({
  vendorId: draft.vendorId.trim(),
  amountCents: Math.round(draft.amount * 100),
  currency: 'USD',
  invoiceNumber: draft.invoiceNumber.trim(),
  invoiceDate: draft.invoiceDate?.format('YYYY-MM-DD') ?? null,
  invoiceDueDate: draft.dueDate?.format('YYYY-MM-DD') ?? null,
  memo: draft.memo.trim() || null,
  invoiceAttachmentId,
  acknowledged: true,
  acknowledgementCopyVersion: BILL_PAYMENT_ACKNOWLEDGEMENT.version,
})

export const sameInvoiceFileReference = (left: File, right: File): boolean =>
  left === right
